import * as z from "@-/com.npmjs.zod";
import { morphemeTierSchema } from "#morpheme-tier";
import { graphemeSliceSchema } from "#grapheme-slice";
import { graphemeStrokeListSchema } from "#grapheme-stroke-slice";

export const componentButtonMorphemeSliceSchema = z.object({
  /**
   * The grapheme's meaning-card back (the `app_grapheme_meaning_card.gloss` for this
   * component's glyph). Used as a fallback when no component mnemonic is defined.
   */
  back: z.string().optional(),
  /** A component.mnemonic term used for decomposition labels. */
  componentMnemonic: z.string().optional(),
  /** All aliases, so a term selected by the parent mnemonic can be styled correctly. */
  componentMnemonicTerms: z.array(z.string()).optional(),
  graphemes: z.array(graphemeSliceSchema).optional(),
  graphemeStrokes: graphemeStrokeListSchema,
  /** Whether the meaning-card gloss itself is a mnemonic rather than a definition. */
  isMeaningMnemonic: z.boolean().optional(),
  pinyin: z.object({
    gloss: z.string().optional(),
    pinyin: z.string(),
  }),
  /** Used to determine if we show the pinyin or not */
  tier: morphemeTierSchema,
});

export type ComponentButtonMorphemeSlice = z.infer<typeof componentButtonMorphemeSliceSchema>;
